module.exports = __webpack_public_path__ + "img/customers.3c88c6f6.png";